export default "__VITE_ASSET__CLpedz0F__"